import { QRFC } from "./QRFC";

export class QScimTokenRFC extends QRFC {
  constructor() {
    super();
    this._mode = "list";
  }

  InitScimTokenRFC(callbackObj, mode) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(false);
    this._mode = mode;
  }

  GetCallName() {
    switch (this._mode) {
      case "create":
        return "scim/tokens/create";
      case "delete":
        return "scim/tokens/delete";
      case "list":
      default:
        return "scim/tokens/list";
    }
  }

  SetParams(org, user, extra) {
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
    if (extra && extra.tokenId) {
      this.AddEncodedParameter("tokenId", extra.tokenId);
    }
  }

  DoTransactionComplete(response, callbackObj) {
    let parsed;
    try {
      parsed = JSON.parse(response);
    } catch (e) {
      callbackObj.ScimTokenResult({ success: false, message: "Invalid response" });
      return;
    }
    callbackObj.ScimTokenResult(parsed);
  }
}
